import React from 'react';

import { View } from '../View';
import Text from '../Text';

import { styleUtils } from '../../utils';

import styles from './styles';

const { style } = styleUtils;

const TagContainer = style(View, styles.tagContainer);
const TagLabel = style(Text, styles.tagLabel);

const Tag = ({ children }) => (
  <TagContainer>
    <TagLabel>{children}</TagLabel>
  </TagContainer>
);

export default Tag;
